import { render, staticRenderFns } from "./BaseTreeSelectTopic.vue?vue&type=template&id=58d86611&"
import script from "./BaseTreeSelectTopic.vue?vue&type=script&lang=js&"
export * from "./BaseTreeSelectTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d86611')) {
      api.createRecord('58d86611', component.options)
    } else {
      api.reload('58d86611', component.options)
    }
    module.hot.accept("./BaseTreeSelectTopic.vue?vue&type=template&id=58d86611&", function () {
      api.rerender('58d86611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTreeSelectTopic.vue"
export default component.exports